import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';

export default function Merci() {
  const pageUrl = 'https://depanfenetres-lyon.fr/merci/';
  // Page de confirmation : ne pas indexer
  useEffect(() => {
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, follow');
    return () => { robots?.setAttribute('content', 'index, follow'); };
  }, []);

  return (
    <>
      <SEOHead
        title="Merci — votre demande est bien envoyée | DFPRO Lyon"
        description="Votre demande a bien été transmise à DFPRO Lyon. Nous vous recontactons rapidement. Pour une urgence, appelez le 09 80 80 36 84, 7j/7."
        canonicalUrl={pageUrl}
      />
      <Header />
      <main>
        <section className="w-full bg-background-50 py-20 md:py-28">
          <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-accent-500 text-3xl w-9 h-9 flex items-center justify-center"></i>
            </div>
            <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900 leading-tight">
              Merci, votre demande est bien envoyée
            </h1>
            <p className="mt-4 text-base text-secondary-600 leading-relaxed">
              Notre équipe vous recontacte au plus vite. Pour une intervention urgente à Lyon,
              le plus rapide reste de nous appeler directement — nous répondons 7j/7.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a href="tel:+33980803684"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap">
                <i className="ri-phone-fill w-4 h-4 flex items-center justify-center"></i>
                09 80 80 36 84
              </a>
              <a href="/"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap">
                <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                Retour à l'accueil
              </a>
            </div>
            <p className="mt-8 text-sm text-secondary-500">
              Devis gratuit · Garantie 10 ans · Intervention 24-48h, 7j/7
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
